import { forwardRef } from "react";
import { SVGIconRoot, SVGStrokePath } from "./SVGComponents";
import { IconProps } from "./index";

export const Check = forwardRef<SVGSVGElement, IconProps>((props, ref) => {
  return (
    <SVGIconRoot viewBox="0 0 22 17" ref={ref} {...props}>
      <SVGStrokePath
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.00002 12.2L3.80002 7.99998L2.40002 9.39998L8.00002 15L20 2.99998L18.6 1.59998L8.00002 12.2Z"
        strokeWidth="2"
      />
    </SVGIconRoot>
  );
});
